const prod = [{
        hot: true,
        img: 'https://4.imimg.com/data4/ID/TR/MY-3712175/rose-flower-500x500.jpg',
        category: 'Rose',
        name: 'Red Rose',
        description: 'Do id sit commodo ut. Irure ullamco enim ex quis dolor esse labore eiusmod occaecat mollit mollit ea. Nostrud do esse tempor cillum in ullamco labore amet laboris labore ipsum anim. Lorem est tempor labore deserunt. Ullamco elit Lorem duis magna eiusmod id in adipisicing culpa ut. In officia sint sit ipsum irure magna velit occaecat sit. Incididunt aute non et aliquip nostrud fugiat ut reprehenderit sint esse deserunt.',
        priceOld: 750,
        priceNew: 600
    },
    {
        hot: false,
        img: 'https://cdn.shopify.com/s/files/1/0014/6256/6963/products/f9a55639831534e344ce1a51a50dc33f_1200x1200.png?v=1524733304',
        category: 'Orchid',
        name: 'Sri Lankan Orchid',
        description: 'Do id sit commodo ut. Irure ullamco enim ex quis dolor esse labore eiusmod occaecat mollit mollit ea. Nostrud do esse tempor cillum in ullamco labore amet laboris labore ipsum anim. Lorem est tempor labore deserunt. Ullamco elit Lorem duis magna eiusmod id in adipisicing culpa ut. In officia sint sit ipsum irure magna velit occaecat sit. Incididunt aute non et aliquip nostrud fugiat ut reprehenderit sint esse deserunt.',
        priceOld: 860,
        priceNew: 720
    },
    {
        hot: true,
        img: 'https://www.anthura.nl/wp-content/themes/anthura/local/images/3439.png',
        category: 'Anthuriam',
        name: 'Red Anthuriam',
        description: 'Do id sit commodo ut. Irure ullamco enim ex quis dolor esse labore eiusmod occaecat mollit mollit ea. Nostrud do esse tempor cillum in ullamco labore amet laboris labore ipsum anim. Lorem est tempor labore deserunt. Ullamco elit Lorem duis magna eiusmod id in adipisicing culpa ut. In officia sint sit ipsum irure magna velit occaecat sit. Incididunt aute non et aliquip nostrud fugiat ut reprehenderit sint esse deserunt.',
        priceOld: 600,
        priceNew: 450
    },
    {
        hot: true,
        img: 'https://www.anthura.nl/wp-content/themes/anthura/local/images/4915.png',
        category: 'Anthuriam',
        name: 'White Anthuriam',
        description: 'Do id sit commodo ut. Irure ullamco enim ex quis dolor esse labore eiusmod occaecat mollit mollit ea. Nostrud do esse tempor cillum in ullamco labore amet laboris labore ipsum anim. Lorem est tempor labore deserunt. Ullamco elit Lorem duis magna eiusmod id in adipisicing culpa ut. In officia sint sit ipsum irure magna velit occaecat sit. Incididunt aute non et aliquip nostrud fugiat ut reprehenderit sint esse deserunt.',
        priceOld: 600,
        priceNew: 450
    },
    {
        hot: true,
        img: 'https://www.kindpng.com/picc/m/2-29008_bougainvillea-plant-in-a-pot-png-transparent-png.png',
        category: 'Bougainvillea ',
        name: 'Purple Bougainvillea ',
        description: 'Do id sit commodo ut. Irure ullamco enim ex quis dolor esse labore eiusmod occaecat mollit mollit ea. Nostrud do esse tempor cillum in ullamco labore amet laboris labore ipsum anim. Lorem est tempor labore deserunt. Ullamco elit Lorem duis magna eiusmod id in adipisicing culpa ut. In officia sint sit ipsum irure magna velit occaecat sit. Incididunt aute non et aliquip nostrud fugiat ut reprehenderit sint esse deserunt.',
        priceOld: 600,
        priceNew: 450
    }, {
        hot: true,
        img: 'https://cdn.shopify.com/s/files/1/1291/5281/products/Yellow_potted_rose_plant_postabloom_1024x1024.jpg?v=1581193274',
        category: 'Rose',
        name: 'Yellow Rose',
        description: 'Do id sit commodo ut. Irure ullamco enim ex quis dolor esse labore eiusmod occaecat mollit mollit ea. Nostrud do esse tempor cillum in ullamco labore amet laboris labore ipsum anim. Lorem est tempor labore deserunt. Ullamco elit Lorem duis magna eiusmod id in adipisicing culpa ut. In officia sint sit ipsum irure magna velit occaecat sit. Incididunt aute non et aliquip nostrud fugiat ut reprehenderit sint esse deserunt.',
        priceOld: 600,
        priceNew: 450
    },


]

export default prod;